import { Component, OnInit } from '@angular/core';
import { DwDecoratorType, DwGridColumn, DwGridColumnBaseComponent } from '@devwareapps/devware-cap';
import { AviatorAvatarColumnConfig } from './models/aviator-avatar-column-config.model';
import { AviatorAvatarColumnConfigComponent } from './aviator-avatar-column-config/aviator-avatar-column-config.component';



@DwGridColumn({
  keyName: 'aviator-avatar-column',
  display: 'Aviator Avatar Column',
  decoratorType: DwDecoratorType.component,
  configComponent: AviatorAvatarColumnConfigComponent,
  isGlobal: true,
  allowAction: true,
  showActionButtonConfig: false,
  requireAction: false,
  useAutoRowHeight: false,
  allowAttr: false,
  requireAttr: false
})
@Component({
  selector: 'app-aviator-avatar-column',
  template: `
   <div class="mt-1">
    <app-aviator-avatar [hidden]="hideAvatar"
      [firstName]="firstName"
      [lastName]="lastName"
      [fullName]="fullName"
      [userImageMediaPath]="userImageMediaPath"
    ></app-aviator-avatar>
    </div>
  `,
})
export class AviatorAvatarColumnComponent extends DwGridColumnBaseComponent<AviatorAvatarColumnConfig> {
  firstName: any;
  lastName: any;
  fullName: any;
  userImageMediaPath: any;

  hideAvatar: boolean = true;

  setupColumn() {
    const rawData = this.params.data;

    if (!rawData) {
      this.hideAvatar = true;
      return;
    }

    this.hideAvatar = false;

    if (this.gridColumnConfig?.firstNameField) {
      this.firstName = rawData[this.gridColumnConfig.firstNameField];
    }
    if (this.gridColumnConfig?.lastNameField) {
      this.lastName = rawData[this.gridColumnConfig.lastNameField];
    }

    if (this.gridColumnConfig?.fullNameField) {
      this.fullName = rawData[this.gridColumnConfig.fullNameField];
    }

    if (this.gridColumnConfig?.mediaPathField) {
      this.userImageMediaPath = rawData[this.gridColumnConfig.mediaPathField];
    }
  }

}
